import { gql } from '@apollo/client'

const GET_CAMPAIGNS = gql`
  query campaigns($nonprofitOrgId: Int!, $createdAfter: Int) {
    campaigns(nonprofitOrgId: $nonprofitOrgId, createdAfter: $createdAfter) {
      id
      nonprofitOrgId
      name
      createdAt
      updatedAt
      archivedAt
      createdUserId
      updatedUserId
      publishedAt
      fundraisingTarget
      portalId
      hashedPortalId
      initiativeGoalId
      draftGoalName
      draftObjectiveName
      firstPublishedAt
      initiativeGoalId
      donations {
        id
        donorStripeAccountId
        createdAt
        amount
        netAmount
        refunded
        disputed
      }
    }
  }
`

export default GET_CAMPAIGNS
